export const ANCHOR_POINTS = [6, 16, 28];
export const ANCHOR_POINTS_MAP = {
  VR2: [6, 16, 28],
};
export const DISTANCE_DAMPER = 120;
export const TOTAL_IMAGES = 33;
